import React from 'react';

const SocialContacts = () => {
    return (
        <div className='container'>
            <div className='text-center mt-20 mb-20 pt-20 pb-20 bg-gradient-to-t from-black to-red-300'>
                <p className='text-white font-semibold text-3xl'><span className='text-black font-bold'>Phone Number:</span> +718-340-5499</p>
                <p className='text-white font-semibold text-3xl'><span className='text-black font-bold'>Email:</span> yourfragrance11@gmail.columns</p>
                <p className='text-white font-semibold text-3xl'><span className='text-black font-bold'>Address:</span> 32/3 McGraw Ave. Bronx NY</p>
            </div>
        </div>
    );
};

export default SocialContacts;